import { nextTick } from "vue";

export const useRestoreScroll = (el: HTMLElement | undefined) => {
  /**
   * Restores element scroll position if it changed when callback ran.
   */
  const restoreScroll = async (cb: () => void): Promise<void> => {
    if (!el) {
      return cb();
    }

    const { scrollTop, scrollHeight } = el;

    cb();
    await nextTick();

    const { scrollTop: newScrollTop, scrollHeight: newScrollHeight } = el;

    // Element height changed and scrolling was not handled by the browser
    if (newScrollHeight !== scrollHeight && scrollTop === newScrollTop) {
      el.scrollBy({ top: newScrollHeight - scrollHeight });
    }
  };

  return {
    restoreScroll
  };
};
